import { FC } from "react";
import { twMerge } from "tailwind-merge";

import {
  getOfficialSubmission,
  isUnseenSubmissionAfterAssessment,
} from "components/materials/page/helpers";
import type { SubmissionType } from "components/server-types";
import { t } from "i18n/i18n";

interface NewSubmissionBadgeProps {
  /** Submissions for the student/group, sorted descending by created_at (latest first) */
  sortedSubmissions: Pick<
    SubmissionType,
    "created_at" | "seen_after_assessed_at" | "official_at"
  >[];
  className?: string;
}

/**
 * Displays a "NEW" badge when a student submits again after their response was assessed.
 * A later submission that already existed when an older one was made official is not new.
 */
export const NewSubmissionBadge: FC<NewSubmissionBadgeProps> = ({
  sortedSubmissions,
  className,
}) => {
  const officialSubmission = getOfficialSubmission(sortedSubmissions);
  // Submissions are sorted descending by created_at, so the first one is the latest.
  const latestSubmission = sortedSubmissions[0];
  if (
    !latestSubmission ||
    !isUnseenSubmissionAfterAssessment(latestSubmission, officialSubmission)
  ) {
    return null;
  }

  return (
    <span className={twMerge("shrink-0 text-sm font-bold uppercase text-blue", className)}>
      {t("student_assessment_queue.new_submission")}
    </span>
  );
};
